import { Button, Checkbox, Typography, withStyles } from '@material-ui/core';
import React from 'react';
import { withRouter } from 'react-router';
import { compose, withState } from 'recompose';
import ErrorIcon from '@material-ui/icons/Error';
import { nameSystem } from '../../constants/TextSystem';

const styles = {
  contentContainer: {
    backgroundColor: '#fff',
    borderRadius: 4,
    width: '100%',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    '@media (max-height: 750px)': {
      maxHeight: 600,
      overflowY: 'auto'
    }
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 10,
    textAlign: 'center'
  },
  body: {
    padding: '40px 30px'
  },
  marginBottom32: {
    marginBottom: 32
  },
  buttonConfirm: {
    width: '100%',
    fontSize: 14,
    fontWeight: 700
  },
  menuName: {
    fontSize: 16,
    fontWeight: 400,
    marginBottom: 5
  },
  p0: {
    padding: 0
  },
  amountBox: {
    margin: '8px 0 24px'
  },
  warningBox: {
    backgroundColor: '#FFEEEF',
    border: '1px solid #FFEEEF',
    borderRadius: 8,
    display: 'flex',
    padding: 8,
    marginBottom: 8
  },
  warningIcon: {
    width: 24,
    height: 24,
    color: '#FF545C'
  },
  warningText: {
    marginLeft: 4,
    fontSize: 14,
    fontWeight: 400
  },
  checkLine: {
    display: 'flex',
    alignItems: 'center'
  },
  checkBox: {
    padding: 0,
    marginRight: 8
  },
  buttonBack: {
    width: '100%',
    fontSize: 14,
    fontWeight: 700,
    marginTop: 16
  }
};

const enhance = compose(withState('policy1', 'setPolicy1', false));

const Main = enhance(
  ({
    classes,
    editAmountEducationSystem,
    policy1,
    setPolicy1,
    amountUpdated,
    backConfirmUpdateAmount,
    gochiChoseUpdateAmount,
    isAdmin,
    systemNameGochiChoseUpdateAmount,
    oldAmountUpdateAmount
  }) => {
    let systemName = '';

    if (systemNameGochiChoseUpdateAmount === nameSystem.fukuoka) {
      systemName = '福岡市';
    } else if (systemNameGochiChoseUpdateAmount === nameSystem.suita) {
      systemName = '吹田市';
    } else if (systemNameGochiChoseUpdateAmount === nameSystem.nishiwaki) {
      systemName = '西脇市';
    } else if (systemNameGochiChoseUpdateAmount === nameSystem.hamamatsu) {
      systemName = '浜松市';
    } else if (systemNameGochiChoseUpdateAmount === nameSystem.sagamihara) {
      systemName = '相模原市';
    }

    return (
      <>
        <div className={classes.contentContainer}>
          <div className={classes.body}>
            <Typography className={classes.title} variant="h6">
              金額修正 確認
            </Typography>
            <Typography className={classes.menuName}>
              コース名：
              {gochiChoseUpdateAmount.menuName}
            </Typography>

            <div className={classes.amountBox}>
              <Typography className={classes.p0}>
                <span>修正前：</span>
                <span>
                  {oldAmountUpdateAmount
                    ? Number(oldAmountUpdateAmount).toLocaleString()
                    : 0}
                </span>
                <span>円</span>
              </Typography>
              <Typography className={classes.p0}>
                <span>修正後：</span>
                <span>
                  {amountUpdated ? Number(amountUpdated).toLocaleString() : 0}
                </span>
                <span>円</span>
              </Typography>
            </div>

            {!isAdmin && (
              <div className={classes.marginBottom32}>
                <div className={classes.warningBox}>
                  <ErrorIcon className={classes.warningIcon} />
                  <div className={classes.warningText}>
                    「注意事項」
                    <br />
                    参画事業者が金額修正を行った結果生じたトラブルについては、⾃らの責任において解決するものとします。
                    <br />
                    {systemName}
                    及び運営事務局は⼀切の責任を負いません。
                  </div>
                </div>

                <div className={classes.checkLine}>
                  <Checkbox
                    color="primary"
                    className={classes.checkBox}
                    checked={policy1}
                    onChange={event => {
                      setPolicy1(event.target.checked);
                    }}
                  />
                  上記の注意事項に同意する
                </div>
              </div>
            )}

            <div>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  editAmountEducationSystem();
                }}
                className={classes.buttonConfirm}
                disabled={!policy1 && !isAdmin}
              >
                確定する
              </Button>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => {
                  backConfirmUpdateAmount();
                }}
                className={classes.buttonBack}
              >
                戻る
              </Button>
            </div>
          </div>
        </div>
      </>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
